var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var _a;
import React, { Component } from 'react';
import cxs from 'cxs/component';
import Theme, { mediaQueries } from 'Theme';
import { T } from 'helpers/i18n';
import { BackgroundImage } from 'elements';
import { Tooltip } from 'reactstrap';
import Button from './Button';
import Text from './Text';
var InputImage = /** @class */ (function (_super) {
    __extends(InputImage, _super);
    function InputImage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            image: _this.props.value,
            tooltip: false
        };
        _this.handleImage = function (event) {
            // console.log('FieldImage - handleImage')
            var isValid = function (file, accept) {
                return (accept.includes('image/*') && file.type.includes('image') || (file.type === accept));
            };
            if (event.target.files && event.target.files.length > 0) {
                event.persist();
                var files = event.target.files;
                if (files.length > 1) {
                    // compruebo si todas son válidas (type es image/..... en )
                }
                // cargo en el input la primera
                var file = files[0];
                var accept = _this.props.accept || 'image/*';
                var validAccept = isValid(file, accept);
                if (validAccept) {
                    var fileReader_1 = new FileReader();
                    fileReader_1.onload = function () {
                        _this.setState({ image: fileReader_1.result }); // as string porque uso readAsDataURL representando el dato como base64 string
                    };
                    fileReader_1.readAsDataURL(file);
                    _this.props.onChange(_this.props.name, files, _this.props.column);
                }
                else {
                    console.log('FieldImage - handleImage - !validAccept');
                }
            }
            else {
                console.log('FieldImage - handleImage - no files');
            }
        };
        _this.handleToggleTooltip = function () {
            _this.setState(function (prev) { return ({ tooltip: !prev.tooltip }); });
        };
        _this.handleDelete = function (name, column) {
            _this.props.onChange(name, null, column);
            _this.setState({ image: null });
        };
        return _this;
    }
    InputImage.prototype.render = function () {
        var _this = this;
        var _a = this.props, name = _a.name, footer = _a.footer, accept = _a.accept, id = _a.id, tooltipContent = _a.tooltipContent, column = _a.column, style = _a.style, deletable = _a.deletable, multiple = _a.multiple;
        var image = this.state.image;
        return (React.createElement(Wrapper, { id: id, style: style },
            React.createElement(Label, null, T(name)),
            image && deletable && React.createElement(Button, { style: { width: '100%' }, onClick: function () { return _this.handleDelete(name, column); } },
                React.createElement(Text, { center: true }, T('removeImage'))),
            React.createElement(BackgroundImage, { style: { maxWidth: '60%', maxHeight: '60%' }, image: !multiple && image },
                React.createElement(StyledInput, { multiple: this.props.multiple, type: "file", accept: accept ? accept : 'image/*', onChange: this.handleImage })),
            React.createElement(StyledText, null, footer ? footer : T('imageProperties')),
            id && React.createElement(Tooltip, { target: id, isOpen: this.state.tooltip, toggle: this.handleToggleTooltip }, tooltipContent)));
    };
    return InputImage;
}(Component));
export default InputImage;
var Wrapper = cxs('div')((_a = {
        maxWidth: '60%',
        margin: 'auto'
    },
    _a[mediaQueries.desktop] = {
        maxWidth: Theme.common.size.maxWidth / 3 + 'px'
    },
    _a));
var Label = cxs('p')({
    color: Theme.color.placeholder,
    textAlign: 'center'
});
var StyledInput = cxs('input')({
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    opacity: 0,
    cursor: 'pointer'
});
var StyledText = cxs('div')({
    textTransform: 'none',
    textAlign: 'center',
    fontSize: Theme.fontSize.small,
    color: Theme.color.placeholder,
    padding: "".concat(Theme.size.space[1], " 0 ").concat(Theme.size.space[2])
});



//////////////////
// WEBPACK FOOTER
// ./src/elements/FieldImage.tsx
// module id = 243
// module chunks = 0